
(function(){
  var end = Date.now() + 10*60*1000;
  var els = document.querySelectorAll('[data-timer]');
  function tick(){
    var left = Math.max(0, Math.floor((end-Date.now())/1000));
    var m = String(Math.floor(left/60)).padStart(2,'0');
    var s = String(left%60).padStart(2,'0');
    els.forEach(function(e){e.textContent=m+':'+s;});
    if(left===0) clearInterval(id);
  }
  var id=setInterval(tick,1000); tick();
})();

document.addEventListener('DOMContentLoaded', function(){
  var modal=document.getElementById('order-form');
  if(!modal) return;
  function openModal(){
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden','false');
    document.body.classList.add('order-modal-open');
    var first=modal.querySelector('input:not([type="hidden"])');
    if(first) setTimeout(function(){first.focus();},50);
  }
  function closeModal(){
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden','true');
    document.body.classList.remove('order-modal-open');
  }
  document.querySelectorAll('.order-form-trigger').forEach(function(btn){
    btn.addEventListener('click',function(e){e.preventDefault();openModal();});
  });
  modal.querySelectorAll('[data-close-order]').forEach(function(el){
    el.addEventListener('click',closeModal);
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape') closeModal();});
});
